// extracted by mini-css-extract-plugin
export var cartContainer = "_pk-4";
export var gray = "_pk-1";
export var itemContainer = "_pk-2";
export var itemDetails = "_pk-3";
export var strong = "_pk-0";